import { render, staticRenderFns } from "./PaywallFormPackages.vue?vue&type=template&id=04752d18&scoped=true"
import script from "./PaywallFormPackages.vue?vue&type=script&lang=js"
export * from "./PaywallFormPackages.vue?vue&type=script&lang=js"
import style0 from "./PaywallFormPackages.vue?vue&type=style&index=0&id=04752d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04752d18",
  null
  
)

export default component.exports